module.exports = __webpack_public_path__ + "static/media/logo.33b95c8a.png";